import { gql } from '@apollo/client';
export {
  CreateActivity,
  CreateEpisode,
  DeleteEpisode,
  GetActivityById,
  GetEpisodeById,
  UpdateActivity,
  UpdateEpisode,
  deleteActivity,
  CreateRoad,
  DeleteRoad,
  GetRoadById,
  UpdateRoad,
  GetRankingRoadsList,
  GetRoadDetailsById,
  listUsersByActivity
} from './roads';

export { ListTags, CreateTag } from './tags';
export {
  UpdateCreditInfo,
  UpdateFreemiumInfo,
  UpdateTagsInfo,
  UpdateLiveLink,
  DeleteCreditsSettings,
  CreateCreditsSettings,
  UpdateCreditsSettings,
  ClaimedCredit
} from './settings';

export {
  CreateNotification,
  DeleteNotification,
  GeNotificationById,
  UpdateNotification
} from './notifications';

export {
  CreateAccomplishment,
  DeleteAccomplishment,
  GetAccomplishmentById,
  UpdateAccomplishment
} from './accomplishment';

export const loginMutation = gql`
  mutation Login($loginAdminInput: LoginAdminInput!) {
    login(loginAdminInput: $loginAdminInput) {
      accessToken
      fullName
      email
      phone
      profile
      permissions
    }
  }
`;
